const MEMBERS_SUBCOLLECTION = "members";
const CAMPAIGNS_COLLECTION = "campaigns";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    ...snap.data(),
    id: snap.id
  };
};

function CampaignMembersMixin(firebase) {
  return {
    async getMembersWithCampaignId(campaignId) {
      return firebase
        .firestore()
        .collection(CAMPAIGNS_COLLECTION)
        .doc(campaignId)
        .collection(MEMBERS_SUBCOLLECTION)
        .get()
        .then(populateSnapshots);
    },

    async updateMembersWithCampaignId(campaignId, memberUpdates) {
      async function deleteAllMembersByCampaignId(campaignId) {
        const collectionRef = firebase
          .firestore()
          .collection("campaigns")
          .doc(campaignId)
          .collection("members");
        const query = collectionRef.orderBy("__name__").limit(450);

        return new Promise((resolve, reject) => {
          deleteQueryBatch(query, resolve).catch(reject);
        });
      }

      async function deleteQueryBatch(query, resolve) {
        const snapshot = await query.get();

        const batchSize = snapshot.size;
        if (batchSize === 0) {
          // When there are no documents left, we are done
          resolve();
          return;
        }

        // Delete documents in a batch
        const batch = firebase.firestore().batch();
        snapshot.docs.forEach((doc) => {
          batch.delete(doc.ref);
        });
        await batch.commit();

        // Recurse on the next process tick, to avoid
        // exploding the stack.
        process.nextTick(() => {
          deleteQueryBatch(query, resolve);
        });
      }
      await deleteAllMembersByCampaignId(campaignId).catch(() => {});
      const batch = firebase.firestore().batch();
      const newMembers = [];
      memberUpdates.forEach((member) => {
        const memberRef = firebase
          .firestore()
          .collection(CAMPAIGNS_COLLECTION)
          .doc(campaignId)
          .collection(MEMBERS_SUBCOLLECTION)
          .doc(member.userId);
        batch.set(memberRef, member);
        newMembers.push({ ...member, id: memberRef.id });
      });
      await batch.commit();
      return newMembers;
    },

    async copyCampaignMembers(campaignId, newCampaignId) {
      const members = await this.collection("campaigns")
        .doc(campaignId)
        .collection("members")
        .get();
      for (let member of members.docs) {
        await this.collection("campaigns")
          .doc(newCampaignId)
          .collection("members")
          .doc(member.id)
          .set(member.data());
      }
    },

    async addMemberToCampaign(campaignId, member) {
      const memberRef = firebase
        .firestore()
        .collection(CAMPAIGNS_COLLECTION)
        .doc(campaignId)
        .collection(MEMBERS_SUBCOLLECTION)
        .doc(member.userId);
      await memberRef.set(member);
      return { ...member, id: memberRef.id };
    }
  };
}

module.exports = CampaignMembersMixin;
